import { CorrelationIds } from '@internal/ondemand-admin-api-helper';

export interface SupportReference {
  // The id the user should quote to support
  reference?: string;
  correlationId?: string;
}

const getHeader = (
  response: Pick<Response, 'headers'> | undefined,
  name: string,
) => response?.headers?.get?.(name) || undefined;

// Picks the most useful id to quote to support: the X-Ray trace id spans the
// whole workflow, then the execution name, then the correlation id. Responses
// that never reached our API only carry the API Gateway request id header.
export const getSupportReference = (
  body?: Partial<CorrelationIds> | null,
  response?: Pick<Response, 'headers'>,
): SupportReference | undefined => {
  const correlationId =
    body?.correlationId || getHeader(response, 'x-correlation-id');
  const reference =
    body?.traceId ||
    body?.executionName ||
    correlationId ||
    getHeader(response, 'x-amzn-requestid');

  return reference ? { reference, correlationId } : undefined;
};

export const formatSupportReference = (
  support?: SupportReference,
): string | undefined => {
  if (!support?.reference) {
    return undefined;
  }
  const correlation =
    support.correlationId && support.correlationId !== support.reference
      ? ` (Correlation ID: ${support.correlationId})`
      : '';
  return `Reference: ${support.reference}${correlation}`;
};
